import Vue from 'vue';

import AsideLayout from "@/components/common/AsideLayout";
Vue.component('AsideLayout', AsideLayout);

import CardContainer from "@/components/portal/CardContainer";
Vue.component('CardContainer', CardContainer);

import ListContainer from "@/components/portal/ListContainer";
Vue.component('ListContainer', ListContainer);

import ListTab from "@/components/portal/ListTab";
Vue.component('ListTab', ListTab);

import ListClassification from "@/components/portal/ListClassification";
Vue.component('ListClassification', ListClassification);

import ListSearch from "@/components/portal/ListSearch";
Vue.component('ListSearch', ListSearch);

import ListBaseItem from "@/components/portal/ListBaseItem";
Vue.component('ListBaseItem', ListBaseItem);

import ListGridLayout from "@/components/portal/ListGridLayout";
Vue.component('ListGridLayout', ListGridLayout);

import ListMoreItem from "@/components/portal/ListMoreItem";
Vue.component('ListMoreItem', ListMoreItem);

import TagView from "@/components/portal/TagView";
Vue.component('TagView', TagView);

import RankItem from "@/components/portal/RankItem";
Vue.component('RankItem', RankItem);

import RelationShipPanel from "@/components/portal/RelationShipPanel";
Vue.component('RelationShipPanel', RelationShipPanel);

import SimpleItem from "@/components/portal/SimpleItem";
Vue.component('SimpleItem', SimpleItem);

import DetailSection from "@/components/portal/DetailSection";
Vue.component('DetailSection', DetailSection);

import ModalView from "@/components/portal/ModalView";
Vue.component('ModalView', ModalView);

import MoAffix from "@/components/portal/MoAffix";
Vue.component('MoAffix', MoAffix);

import ManagerPage from "@/components/manager/ManagerPage";
Vue.component('ManagerPage', ManagerPage);

import CountTo from "vue-count-to";
Vue.component('CountTo', CountTo);

